/*
 * Copyright (C) 2014 Spanning Cloud Apps.  All rights reserved.
 */
import './list/list.js';
import './receipt/receipt.js';
import './receipts.tpl.html';
import './receiptsContent.tpl.html';
import './toolbar/toolbar.js';

angular
  .module('receipts', [
    'ui.router',
    'ngAnimate',
    'receipts.list',
    'receipts.receipt',
    'receipts.toolbar',
    'sbsf.constants'
  ])
  // This defines the main abstract receipts view that is shared across all
  // subviews.
  .config([
    '$stateProvider',
    'VIEW_STATES',
    function ($stateProvider, VIEW_STATES) {
      $stateProvider
        .state(VIEW_STATES.RECEIPTS, {
          abstract: true,
          views: {
            content: {
              templateUrl: 'receipts/receipts.tpl.html'
            }
          }
        })
        // The views that are rendered in the receipts view.
        .state(VIEW_STATES.RECEIPTS_CONTENT, {
          url: '/receipts',
          resolve: {
            extraInfo: [
              'httpBilling',
              function (httpBilling) {
                return httpBilling.getExtraInfo();
              }
            ],
            transactions: [
              'httpBilling',
              function (httpBilling) {
                return httpBilling.getTransactions();
              }
            ],
            orgInfo: [
              'accountUtils',
              function (accountUtils) {
                return accountUtils.getOrgInfo();
              }
            ]
          },
          views: {
            progress: {
              templateUrl: 'shared/progress/progress.tpl.html',
              controller: 'SharedProgressCtrl'
            },
            receiptsContent: {
              templateUrl: 'receipts/receiptsContent.tpl.html',
              controller: 'ReceiptsCtrl'
            },
            toolbar: {
              templateUrl: 'receipts/toolbar/toolbar.tpl.html',
              controller: 'ReceiptsToolbarCtrl'
            }
          }
        })
        .state(VIEW_STATES.RECEIPTS_CONTENT_LIST, {
          url: '/list',
          views: {
            receiptsDetails: {
              templateUrl: 'receipts/list/list.tpl.html',
              controller: 'ReceiptsListCtrl'
            }
          }
        })
        .state(VIEW_STATES.RECEIPTS_CONTENT_RECEIPT, {
          url: '/receipt/{receiptId}',
          resolve: {
            receiptMarkup: [
              '$stateParams',
              'httpBilling',
              function ($stateParams, httpBilling) {
                return httpBilling.getReceiptContent($stateParams.receiptId);
              }
            ]
          },
          views: {
            receiptsDetails: {
              templateUrl: 'receipts/receipt/receipt.tpl.html',
              controller: 'ReceiptsReceiptCtrl'
            }
          }
        });
    }
  ])
  /**
   *  Controller for the overall receipts view.
   */
  .controller('ReceiptsCtrl', [
    '$scope',
    '$rootScope',
    'VIEW_STATES',
    function ($scope, $rootScope, VIEW_STATES) {
      var me = $scope;
      $scope.animationCls = 'sbsf-slide-switch-left';

      // Listener to state change that will toggle the animation class of the view in the receiptContent template.
      // This results in the left and right sliding animation.
      $rootScope.$on('$stateChangeSuccess', function (event, toState) {
        if (toState.name === VIEW_STATES.RECEIPTS_CONTENT_RECEIPT) {
          me.animationCls = 'sbsf-slide-switch-right';
        } else {
          me.animationCls = 'sbsf-slide-switch-left';
        }
      });
    }
  ]);
